
function addCommas(nStr){
	nStr += '';
	let x = nStr.split('.');
	let x1 = x[0];
	let x2 = x.length > 1 ? '.' + x[1] : '';
	let rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
};

function format(value){
	return addCommas(value.toFixed(3));
};

export class HierarchicalSlider{

	constructor(params = {}){

		this.element = document.createElement("div");

		this.labels = [];
		this.sliders = [];
		this.range = params.range != null ? params.range : [0, 1];
		this.slide = params.slide != null ? params.slide : null;
		this.step = params.step != null ? params.step : 0.0001;
		this.labelText = params.label != null ? params.label : "Range";
		this.fineMode = false;
		this.fineDamping = params.fineDamping != null ? params.fineDamping : 0.05;
		this.fineToggle = null;
		this.lastProposed = null;

		let levels = params.levels != null ? params.levels : 1;

		for(let level = 0; level < levels; level++){
			this.addLevel();
		}

	}

	setRange(range){
		this.range = [...range];

		{ // root slider
			let slider = this.sliders[0];

			$(slider).slider({
				min: range[0],
				max: range[1],
			});
		}

		for(let i = 1; i < this.sliders.length; i++){
			let parentSlider = this.sliders[i - 1];
			let slider = this.sliders[i];

			let parentValues = $(parentSlider).slider("option", "values");
			let childRange = [...parentValues];

			$(slider).slider({
				min: childRange[0],
				max: childRange[1],
			});
		}

		this.updateLabels();
	}

	setValues(values){
		for(let slider of this.sliders){
			$(slider).slider({
				values: [...values],
			});
		}

		this.updateLabels();
	}

	setFineMode(enabled){
		this.fineMode = enabled;
		if(this.fineToggle){
			this.fineToggle.classList.toggle("active", enabled);
		}
	}

	createFineToggle(){
		let btn = document.createElement("span");
		btn.textContent = "Fine";
		btn.className = "fine-toggle";
		btn.addEventListener("click", () => {
			this.setFineMode(!this.fineMode);
		});
		this.fineToggle = btn;
		return btn;
	}

	addLevel(){
		const elLevel = document.createElement("li");
		const slider = document.createElement("div");

		// Label row: "Range: 1.000 to 2.000   [Fine]"
		const labelRow = document.createElement("div");
		labelRow.style.cssText = "display: flex; align-items: baseline; justify-content: space-between;";

		const labelLeft = document.createElement("span");
		const labelName = document.createTextNode(this.labelText + ": ");
		const labelValues = document.createElement("span");
		labelLeft.append(labelName, labelValues);

		labelRow.append(labelLeft, this.createFineToggle());

		let level = this.sliders.length;
		let [min, max] = [0, 0];

		if(this.sliders.length === 0){
			[min, max] = this.range;
		}else{
			let parentSlider = this.sliders[this.sliders.length - 1];
			[min, max] = $(parentSlider).slider("option", "values");
		}

		$(slider).slider({
			range: true,
			min: min,
			max: max,
			step: this.step,
			values: [min, max],
			slide: (event, ui) => {

				if(this.fineMode){
					let currentValues = $(slider).slider("option", "values");
					let scale = this.fineDamping;

					// On first frame of a drag, just record the proposed position
					if(!this.lastProposed){
						this.lastProposed = [...ui.values];
					}

					// Scale the delta between this frame and last frame's proposed position
					let dampedValues = [
						currentValues[0] + (ui.values[0] - this.lastProposed[0]) * scale,
						currentValues[1] + (ui.values[1] - this.lastProposed[1]) * scale,
					];

					this.lastProposed = [...ui.values];

					$(slider).slider("values", 0, dampedValues[0]);
					$(slider).slider("values", 1, dampedValues[1]);

					if(this.slide){
						this.slide({
							target: this,
							range: this.range,
							values: dampedValues,
						});
					}

					this.updateLabels();

					// Prevent the default un-damped jump
					return false;
				}

				// Normal (non-fine) behavior
				// Set all descendants to same range
				let levels = this.sliders.length;
				for(let i = level + 1; i < levels; i++){
					let descendant = this.sliders[i];

					$(descendant).slider({
						range: true,
						min: ui.values[0],
						max: ui.values[1],
						values: [...ui.values],
					});
				}

				if(this.slide){
					let values = [...ui.values];

					this.slide({
						target: this,
						range: this.range,
						values: values,
					});
				}

				this.updateLabels();
			},
			stop: () => {
				this.lastProposed = null;
			},
		});

		elLevel.append(labelRow, slider);

		this.sliders.push(slider);
		this.labels.push(labelValues);
		this.element.append(elLevel);

		this.updateLabels();
	}

	removeLevel(){

	}

	updateSliders(){

	}

	updateLabels(){

		let levels = this.sliders.length;

		for(let i = 0; i < levels; i++){

			let slider = this.sliders[i];
			let label = this.labels[i];

			let [min, max] = $(slider).slider("option", "values");
			let strMin = format(min);
			let strMax = format(max);
			let strLabel = `${strMin} to ${strMax}`;

			label.innerHTML = strLabel;
		}

	}


}
